import React from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('tcc-apps-marketplace-plugin'));
const MFPlugin = React.lazy(() => import('appsMarketplacePlugin/AppsMarketplacePlugin'));

export const ConnectPluginContainer = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.appsMarketplacePlugin.module-federation'];

  const ConnectPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <ConnectPlugin shouldRenderNavBar={false} />;
};
